// extracted by mini-css-extract-plugin
export default {"cButton2":"buttonHead_cButton2__nyZxZ","cButtonGooey2":"buttonHead_cButtonGooey2__DNkCP","cButtonBlobs2":"buttonHead_cButtonBlobs2__r9zT6"};